import React, { useState, useEffect } from 'react';
import { httpsCallable } from 'firebase/functions';
import { useTranslation } from 'react-i18next';

import { useAppContext } from '../AppContext';

function AuraChamber({ onClose }) {
    const { LucideIcons, appFunctions, setMessage } = useAppContext();
    const { t } = useTranslation();
    const [state, setState] = useState('ANALYZING');
    const [insight, setInsight] = useState(null);
    useEffect(() => {
        const fetchInsight = async () => {
            const getAuraInsight = httpsCallable(appFunctions, 'getAuraInsight');
            try {
                const result = await getAuraInsight();
                setInsight(result.data);
                setState('REVEALED');
            } catch (error) {
                console.error("Error fetching aura insight:", error);
                setMessage(t('auraChamber.analysisError', { message: error.message }));
                onClose();
            }
        };
        fetchInsight();
    }, [appFunctions, setMessage, onClose, t]);
    const auraColor = insight?.color || '#3730a3';
    return (
        <div className="modal-overlay animate-fadeIn" onClick={onClose}>
            <div className="w-full max-w-md text-center relative" onClick={e => e.stopPropagation()}>
                <div className="bg-gray-900/80 backdrop-blur-md p-6 rounded-lg shadow-glow border border-purple-500/50">
                    {state === 'ANALYZING' && (<div className="py-12"><div className="w-24 h-24 rounded-full mx-auto transition-all duration-1000" style={{ backgroundColor: auraColor, boxShadow: `0 0 40px ${ auraColor }, 0 0 80px ${ auraColor } `, animation: 'pulse-slow 2s infinite' }}></div><p className="mt-6 text-lg text-gray-300 animate-pulse">{t('auraChamber.analyzing')}</p></div>)}
                    {state === 'REVEALED' && insight && (<div className="animate-fadeIn"><div className="w-24 h-24 rounded-full mx-auto mb-4 transition-all duration-1000" style={{ backgroundColor: insight.color, boxShadow: `0 0 40px ${ insight.color }, 0 0 80px ${ insight.color } ` }}></div><h3 className="text-2xl font-bold font-playfair" style={{ color: insight.color }}>{insight.colorName}</h3><p className="text-lg text-gray-300 mb-4">{insight.mood}</p><div className="my-4 border-t border-gray-700/50"></div><p className="text-sm text-gray-400">{t('auraChamber.keyThemes')}</p><div className="flex justify-center gap-2 my-2">{insight.themes.map(theme => (<span key={theme} className="bg-gray-700/50 text-gray-200 text-xs font-semibold px-3 py-1 rounded-full">{theme}</span>))}</div><div className="my-4 border-t border-gray-700/50"></div><blockquote className="text-lg italic text-white">"{insight.affirmation}"</blockquote></div>)}
                </div>
                <button onClick={onClose} className="absolute -top-10 right-0 p-2 rounded-full bg-gray-700/50 hover:bg-gray-600/50 text-white transition duration-300" aria-label={t('auraChamber.closeAriaLabel')}><LucideIcons.X size={24} /></button>
            </div>
        </div>
    );
}

export default AuraChamber;